<div class="glass-bg" aria-hidden="true">
  <span class="orb orb--brand"></span>
  <span class="orb orb--zinc"></span>
  <span class="orb orb--ember"></span>
</div>
